<router-outlet></router-outlet>
<p-toast />
<app-shortcut-help></app-shortcut-help>

<p-confirm-dialog>
	<ng-template #headless let-dialog let-onAccept="onAccept" let-onReject="onReject">
		<div class="flex flex-column items-align-center p-6 bg-surface-0 relative">
			<div class="border-circle flex align-items-center justify-content-center absolute top-0 mx-auto aspect-square text-surface-0 inline-flex justify-content-center items-align-center h-6rem w-6rem -mt-6"
				 [class]="dialog.icon === 'pi pi-exclamation-triangle' ? 'bg-red-500' : 'bg-primary'">
				<i [class]="`${dialog.icon} text-5xl text-white mb-2`"></i>
			</div>
			<span class="font-bold text-2xl block mb-2 mt-4">{{ dialog.header }}</span>
			<p class="mb-0" [innerHTML]="dialog.message"></p>
			<div class="flex items-center justify-content-end gap-2 mt-6">
				@let rejectButton = dialog.rejectButtonProps;
				<p-button [label]="rejectButton.label"
						  [outlined]="rejectButton.outlined"
						  [severity]="rejectButton.severity"
						  (onClick)="onReject()" />

				@let confirmButton = dialog.acceptButtonProps;
				<p-button [label]="confirmButton.label"
						  [outlined]="confirmButton.outlined"
						  [severity]="confirmButton.severity"
						  (onClick)="onAccept()" />
			</div>
		</div>
	</ng-template>
</p-confirm-dialog>
